import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { sickNoteQKeys } from "@hooks/queries/sickNote/queryKey";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { SickNote } from "@customTypes/sickNote";


export const useUpdateSickNote = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (sickNote: Partial<SickNote>) => {
      return api.put(`sick_notes/${sickNote.id}`, {
        start_date: sickNote.startDate,
        end_date: sickNote.endDate,
      });
    },
    onSuccess: (_, variables) => {
      // console.log(variables);
      showSuccessNotification({
        title: "success",
        message: "update-sick-note-success",
      });
      queryClient.invalidateQueries({
        queryKey: sickNoteQKeys.patient(variables.patientId as string),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Sick Note]", res);

      handleErrors(res, "mutation");
    },
  });
};
